import React from 'react';
import CartContainer from '../../../Componant/Ecommerce/Cart';

const Cart = () => {
  return (
    <div className='page-body'>
      <CartContainer />
    </div>
  );
};

export default Cart;
